// Strip HTML tags, JS injection attempts, and dangerous patterns from user input.
export const sanitizeInput = (value) => {
  if (typeof value !== 'string') return '';
  return value
    .replace(/<[^>]*>/g, '')            // Strip all HTML tags
    .replace(/javascript\s*:/gi, '')    // Strip JS protocol
    .replace(/on\w+\s*=/gi, '')         // Strip inline event handlers
    .replace(/[<>]/g, '')               // Remove stray angle brackets
    .trim();
};

export const CHAR_LIMITS = {
  deckTitle:    100,
  cardLabel:    50,
  profileName:  80,
  organization: 100,
  description:  300,
  jobTitle:     80,
};

// Clamp value to its character limit after sanitizing.
export const sanitizeAndClamp = (value, limitKey) => {
  const clean = sanitizeInput(value);
  const max = CHAR_LIMITS[limitKey];
  return max ? clean.slice(0, max) : clean;
};
